export const FastStartProfileLabels = {
  t1: "T1",
  t2: "T2",
  t3: "T3",
  t4: "T4",
  totalT: "Total T",
  minimumLoad: "Minimum Load"
};
